export enum statusEnum {
  NEW = 'new',
  QUALIFIED = 'qualified',
  REVIEW = 'review_needed',
  REJECTED = 'rejected',
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
  EXPIRED = 'expired',
  SKIPPED = 'skipped',
  COMPLETED = 'completed',
  INPROGRESS = 'in_progress',
  NOT_STARTED = 'not_started',
  PENDING_QUALIFICATION = 'pending_qualification',
  DRAFT = 'draft',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  UNDER_MODIFICATION = 'under_modification',
  NO_ACTION = 'no_action',
  PAYMENT = 'payment',
  REFUND = 'refund',
  PUBLISHED = 'published',
}
